import { css } from '@emotion/css';
import { Anchor, Group, Text } from '@mantine/core';
import type { Icon } from '@tabler/icons-react';
import HTML from 'shared/components/HTML/HTML';

const boldStyles = css`
  b {
    font-weight: 500;
    color: var(--mantine-color-black-6);
  }
`;

type TenantActivityProps = {
  count: number;
  icon: Icon;
  html: string;
  href: string;
};

export const TenantActivity = ({ count, icon: ActivityIcon, html, href }: TenantActivityProps) => {
  if (count === 0) return null;

  return (
    <Anchor href={href} target="_blank" underline="never">
      <Group gap={10} wrap="nowrap">
        <ActivityIcon size={16} stroke={1.6} color="var(--mantine-color-gray-5)" />
        <Text component="span" fz={13} lh="18px" c="gray.7" className={boldStyles}>
          <HTML html={html} />
        </Text>
      </Group>
    </Anchor>
  );
};
